import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import TextInput from "~/Common-Objects/UI/Forms/TextInput/TextInput";
import AlertDialog from "../../../components/alertDialog";
import axios from "~/data/http/axios";
import i18n from "~/i18n";
import postHogFunctions from '~/Classes/posthog';

export default function AddInboxDialogue({
  onCreated = () => { },
  onClose = () => { }
}) {
  const history = useHistory()
  const [inboxName, setInboxName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [isOverLimit, setIsOverLimit] = useState(false);

  const handleSubmit = async (e) => {
    if (isOverLimit) {
      return history.push('/cp/company/subscription')
    }
    setIsSubmitting(true);
    if (inboxName.length < 3 || !inboxName.trim().length) {
      setError(i18n.t("chat:inbox.leftBar.addInbox.errName"));
      setIsSubmitting(false);
      return { error: true };
    }

    try {
      let newInbox = await axios.post("/inboxes", {
        name: inboxName
      })
      postHogFunctions.capture('inbox_added');
      onCreated(newInbox.data);
    }
    catch (err) {
      let error = i18n.t("chat:inbox.leftBar.addInbox.err");
      if (err?.data?.error) error = err.data.error;
      if (error === 'tierOverLimit') {
        error = i18n.t("chat:inbox.leftBar.addInbox.tierOverLimit");
        setIsOverLimit(true)
      }
      setError(error);
      setIsSubmitting(false);
      return { error: true };
    }
  }

  return (
    <AlertDialog
      open={true}
      title={i18n.t("chat:inbox.leftBar.addInbox.title")}
      description={i18n.t("chat:inbox.leftBar.addInbox.desc")}
      ctaText={isOverLimit ? i18n.t("chat:inbox.leftBar.addInbox.upgrade") : i18n.t("chat:inbox.leftBar.addInbox.button")}
      ctaVariant="primary"
      submitting={isSubmitting}
      onCtaClick={handleSubmit}
      onOpenChange={onClose}
    >
      <TextInput
        value={inboxName}
        focus={true}
        label={i18n.t("chat:inbox.leftBar.addInbox.name")}
        onChange={(e) => setInboxName(e.target.value)}
        onEnterPress={handleSubmit}
        error={error}
      />
    </AlertDialog>
  );
}
